module.exports = __webpack_public_path__ + "static/media/javitott_meglevo_szerzigeny2.da143fca.jpg";